import React from "react";
import MetaElement from "../../components/elements/MetaElement";
import StructuredData from "../../components/elements/StructuredDataElement";
import SeoIntro from "../../components-v2/seo/SeoIntro";
import { productListItems } from "../../utils/seoItems";


import ProductListPage, { onFilterChange } from '../../components/blocks/ProductListPage/ProductListPage';

import dayjs from "dayjs";
import "dayjs/locale/ro";
dayjs.locale('ro');

const Categorie = (props) => {
    const category = props.category || {};
    return (<>
        <MetaElement pageId='categorie/[slug]' variables={{
            title: category.metaTitle,
            description: category.metaDescription
        }}/>
        <StructuredData
            type="ItemList"
            name={category.metaTitle || category.title}
            items={productListItems(props.products)}
        />
        <ProductListPage {...props} view="category" refreshKey={props.refreshKey}></ProductListPage>
        <SeoIntro width="max-w-[1800px]" title={category.title ? `Despre ${category.title}` : undefined}>
            {category.metaDescription}
        </SeoIntro>
    </>)
}

Categorie.getInitialProps = async function(ctx) {
    const category = ctx.query.slug;
    const page = ctx.query.page || 1;
    const sort = ctx.query.sort || 'stocked';
    const sortDirection = ctx.query.sortDirection || 'DESC';

    let arrayFilters = Array.isArray(ctx.query.filters) ? ctx.query.filters : ctx.query.filters ? [ctx.query.filters] : [];

    const filters = (arrayFilters || []).map(filter => {
        let splitFilter = filter.split("_");
        let key = splitFilter[0];
        let values = splitFilter[1].split(";");
        return {
            id: key,
            value: values
        }
    })

    // ?tag=slug,slug → a URL-only product-tag filter (slug-keyed, OR-combined).
    const tagSlugs = ctx.query.tag ? String(ctx.query.tag).split(',').map(s => s.trim()).filter(Boolean) : [];
    if (tagSlugs.length > 0) {
        filters.push({ id: 'filterProductTagSlug', value: tagSlugs });
    }

    const opts = {
        page: page,
        pageSize: 24,
        category,
        sort,
        filters: filters,
        view: 'category'
    }

    const response = await onFilterChange(opts, ctx);

    return { ...response, page, sort, sortDirection, refreshKey: dayjs().format('YYYYMMDDHHmmss') };
}

export default Categorie;
